import type { ChangelogEntry } from "../types";

/** Lukk måned meldte helligdager på ukedager som dager uten timer. */
export const LUKK_MAANED_HELLIGDAGER_2026_11: ChangelogEntry = {
  id: "2026-11-02-lukk-maaned-helligdager",
  date: "2026-11-02",
  title: "Helligdager teller ikke som hull i Lukk måned",
  summary:
    "En helligdag på en ukedag ble talt som en dag uten timer. Nå er helligdager regnet som dekket og vises som «Helligdag» i kalenderen og daglista.",
  sections: [
    {
      heading: "Lukk måned",
      items: [
        {
          title: "Helligdager er ikke hull",
          kind: "rettet",
          body: "Helligdager på ukedager, som skjærtorsdag og 2. påskedag, har ingen forventede timer og telles ikke lenger i «ukedager uten timer». De vises nøytralt som «Helligdag», på samme måte som fravær. Fører du timer på en helligdag, vises dagen som ført.",
        },
      ],
    },
  ],
};
